import React from "react";
import DataTable from "../../../components/DataTable";
const dataJson = [
  {
    id: "d7f8sf8ds",
    sn: "01",
    date: "19/03/2022",
    amount: "$785",
    remarks: "136",
    txnNumber: "sf8se7r",
  },
  {
    id: "f7s7f7df",
    sn: "02",
    date: "18/03/2022",
    amount: "$147",
    remarks: "43",
    txnNumber: "f7sf8s5f",
  },
  {
    id: "sfsf5ff4s4f",
    sn: "03",
    date: "13/03/2022",
    amount: "$479",
    remarks: "23",
    txnNumber: "uiy865",
  },
];

const columns = [
  { id: "sn", label: "S.N", minWidth: 20 },
  { id: "date", label: "Date", minWidth: 100 },
  {
    id: "amount",
    label: "Amount",
    minWidth: 80,
  },
  {
    id: "remarks",
    label: "Remarks",
    minWidth: 80,
  },
  {
    id: "txnNumber",
    label: "Txn Number",
    minWidth: 100,
  },
];

function createData(sn, date, amount, remarks, txnNumber) {
  return {
    sn,
    date,
    amount,
    remarks,
    txnNumber,
  };
}

const rows = dataJson.map((d) =>
  createData(d.sn, d.date, d.amount, d.remarks, d.txnNumber)
);

const AutoPoolBonusTable = () => {
  return (
    <DataTable
      columns={columns}
      rows={rows}
      perPageShow={6}
      tableHeight={440}
      className="common_table"
    />
  );
};

export default AutoPoolBonusTable;
